import styled from 'styled-components'

export const Container = styled.div`

`

export const Content = styled.div`
  min-width: 600px;
  width: 50%;
`

export const ContainerGraph = styled.div`
  height: 300px;
`